<template>
  <div class="more-submenu">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'More-submenu',

  data () {
    return {
    }
  },

  methods: {
  }
}
</script>

<style>

</style>
